import { Components, Theme } from "@mui/material/styles";

export const components = (theme: Theme): Components => ({
  MuiTableHead: {
    styleOverrides: {
      root: {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },
  MuiTableSortLabel: {
    styleOverrides: {
      root: ({ ownerState }) => ({
        ...(ownerState.active && {
          color: theme.palette.primary.main,
        }),
      }),
    },
  },
  MuiToolbar: {
    styleOverrides: {
      root: {
        minHeight: 40,
        paddingLeft: 20,
        paddingRight: 20,
        backgroundColor: "#fff",
        color: theme.palette.primary.main,
        "@media (min-width:600px)": {
          minHeight: 40,
          paddingLeft: 20,
          paddingRight: 20,
        },
      },
    },
  },
  MuiDataGrid: {
    styleOverrides: {
      root: {
        "& .MuiDataGrid-columnHeader": {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          "& .MuiDataGrid-aggregationColumnHeaderLabel": {
            color: "inherit",
          },
          "& .MuiSvgIcon-root": {
            color: theme.palette.primary.contrastText,
          },
          "& .MuiFormLabel-root": {
            color: theme.palette.primary.contrastText,
          },
          "& .MuiOutlinedInput-input": {
            color: theme.palette.primary.contrastText,
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.primary.contrastText,
          },
          "& .MuiOutlinedInput-notchedOutline:hover": {
            borderColor: theme.palette.primary.contrastText,
          },
        },

        "& .MuiDataGrid-toolbar .MuiSvgIcon-root": {
          color: theme.palette.primary.light,
        },
        "& .MuiDataGrid-toolbar .MuiBadge-badge": {
          backgroundColor: theme.palette.primary.main,
        },
      },
    },
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: "8px",
      },
    },
  },
});
